import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PricesIcon(param) {
    let { color } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "23",
        height: "23",
        fill: "none",
        viewBox: "0 0 23 23",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "11.5",
                r: "11",
                stroke: color ? color : "#3F4041"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "11.5",
                cy: "11.5",
                r: "7",
                stroke: color ? color : "#3F4041"
            }),
            /*#__PURE__*/ _jsx("rect", {
                width: "6",
                height: "6",
                x: "8.5",
                y: "8.5",
                stroke: color ? color : "#3F4041",
                rx: "0.5"
            })
        ]
    });
}
